import "../Static Files/styles/tours/tours.css";
import moskva from "../Static Files/Images/HomePage/active tours/moskova_sehir_rehberi.jpg";
import world from "../Static Files/Images/HomePage/active tours/World 32x32.png";
import filterIcon from "../Static Files/Images/tours/Setting 128x128.png";
import {
  Link,
  useLoaderData,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTours,
  fetchDiscountTours,
  fetchSpecialOfferTours,
  fetchHighToLowTours,
  fetchLowToHighTours,
  fetchMinAndMaxPriceTours,
  fetchToursByCategoryId,
  fetchToursByCategoryName,
} from "../slices/tourSlice";

import { fetchCategories } from "../slices/categorySlice";
import { useEffect, useState } from "react";
import ArrowIcon from "../Components/arrowIcon";
import Loading from "../Components/Loading";
import ErrorPage from "../Components/ErrorPage";
import translation from "../locales";

const Tours = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  const dispatch = useDispatch();
  const {
    tours,
    status,
    error,
    lowToHighTours,
    highToLowTours,
    minAndMaxPriceTours,
    categoryIdTours,
    categoryNameTours,
  } = useSelector((state) => state.tours);
  const { categories } = useSelector((state) => state.categories);
  const [filteredTours, setFilteredTours] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [sortOption, setSortOption] = useState("");
  const [categoryOption, setCategoryOption] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const toursPerPage = 4;

  const lang = location.pathname.split("/")[1];
  const currentLang = translation[lang] ? lang : "az";

  useEffect(() => {
    dispatch(fetchTours());
    dispatch(fetchCategories());
  }, [dispatch]);

  useEffect(() => {
    if (sortOption === "recommended") {
      dispatch(fetchTours());
    } else if (sortOption === "lowToHigh") {
      dispatch(fetchLowToHighTours());
    } else if (sortOption === "highToLow") {
      dispatch(fetchHighToLowTours());
    }
  }, [sortOption, dispatch]);

  useEffect(() => {
    if (sortOption === "recommended") {
      setFilteredTours(tours);
    } else if (sortOption === "lowToHigh") {
      setFilteredTours(lowToHighTours);
    } else if (sortOption === "highToLow") {
      setFilteredTours(highToLowTours);
    }
  }, [tours, lowToHighTours, highToLowTours, sortOption]);

  useEffect(() => {
    if (categoryOption > 0) {
      dispatch(fetchToursByCategoryId(categoryOption));
    } else {
      setFilteredTours(tours); // Default olaraq, `tours`u `filteredTours` olaraq təyin edin
    }
  }, [categoryOption, dispatch, tours]);

  useEffect(() => {
    if (categoryIdTours && categoryIdTours.length > 0) {
      setFilteredTours(categoryIdTours); // `categoryIdTours` təkrarlansın
      console.log(filteredTours);
    }
  }, [categoryIdTours, categoryOption]);

  if (status === "loading") {
    return <Loading />;
  }

  if (status === "failed") {
    return <ErrorPage />;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true); // Yükləmə başladılır
    dispatch(fetchMinAndMaxPriceTours({ min, max }))
      .then(() => {
        if (minAndMaxPriceTours && minAndMaxPriceTours.length > 0) {
          setFilteredTours(minAndMaxPriceTours);
        } else {
          setFilteredTours([]); // Əgər nəticə yoxdursa, boş dizi
        }
      })
      .finally(() => {
        setIsLoading(false); // Yükləmə tamamlanır
      });
  };

  const indexOfLastTour = currentPage * toursPerPage;
  const indexOfFirstTour = indexOfLastTour - toursPerPage;
  const currentTours =
    filteredTours && filteredTours.length > 0
      ? filteredTours.slice(indexOfFirstTour, indexOfLastTour)
      : [];

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <main>
        <section className="tours-hero">
          <h1>{translation[currentLang].toursheroh1}</h1>
          <p>{translation[currentLang].toursherop}</p>
        </section>

        <section className="list-section">
          <div className="filter-div">
            <h1>{translation[currentLang].toursfilterh1}</h1>
            <form>
              <input
                className="search-textbox"
                type="text"
                placeholder="e.g Rome"
              />
              <hr />

              <h2 className="sorth2">
                {translation[currentLang].toursfiltersortbytext}
              </h2>
              <div className="radio-div">
                <input
                  type="radio"
                  name="sort"
                  value="recommended"
                  checked={sortOption === "recommended"}
                  onChange={(e) => setSortOption(e.target.value)}
                />
                <label>
                  {translation[currentLang].toursfilterlabelrecommended}
                </label>
              </div>
              <div className="radio-div">
                <input
                  type="radio"
                  name="sort"
                  value="lowToHigh"
                  checked={sortOption === "lowToHigh"}
                  onChange={(e) => setSortOption(e.target.value)}
                />
                <label>
                  {translation[currentLang].toursfilterlabellowtogigh}
                </label>
              </div>
              <div className="radio-div">
                <input
                  type="radio"
                  name="sort"
                  value="highToLow"
                  checked={sortOption === "highToLow"}
                  onChange={(e) => setSortOption(e.target.value)}
                />
                <label>
                  {translation[currentLang].toursfilterlabelhightolow}
                </label>
              </div>

              <div className="total-div">
                <h3>{translation[currentLang].toursfiltertotalprice}</h3>
                <div className="prices-div">
                  <div className="price min-price">
                    <p>Min</p>
                    <div>
                      $
                      <input
                        className="price-input"
                        type="number"
                        placeholder="0"
                        name="min"
                        onChange={(e) => setMin(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="price max-price">
                    <p>Max</p>
                    <div>
                      $
                      <input
                        className="price-input"
                        type="number"
                        placeholder="3000+"
                        name="max"
                        onChange={(e) => setMax(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <input type="range" />

              <div className="special-div">
                <h3>{translation[currentLang].toursfilteroffers}</h3>
                <div className="radio-div">
                  <input type="radio" name="option" value="1" />{" "}
                  <label htmlFor="option">Istənilən</label>
                </div>
                <div className="radio-div">
                  <input type="radio" name="option" value="1" />{" "}
                  <label htmlFor="option">Xüsusi Təklif</label>
                </div>
              </div>

              <div className="category-div">
                <h3>{translation[currentLang].toursfiltercategories}</h3>

                <ul>
                  {categories.map((category) => {
                    return (
                      <li>
                        <div className="radio-div">
                          <input
                            type="radio"
                            name="categorySort"
                            checked={categoryOption === category.id}
                            onChange={() => setCategoryOption(category.id)}
                          />{" "}
                          <label>{category.name}</label>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <button onClick={handleSubmit} type="submit" disabled={isLoading}>
                {isLoading ? "Yüklənir..." : "Göndər"}
              </button>
            </form>
          </div>

          <form className="responsive-search-div">
            {" "}
            <input
              className="search-textbox"
              type="text"
              placeholder="e.g Rome"
            />
            <a onClick={() => setFilterOpen(true)}>
              <img src={filterIcon} alt="icon" />
              <ArrowIcon />
            </a>
          </form>
          <div className="tours-div">
            <ul>
              {currentTours.map((tour) => (
                <li key={tour.id}>
                  <div className="list-card">
                    {tour.isSpecialOffer && (
                      <div className="special-offer">Xüsusi təklif</div>
                    )}
                    {tour.hasDiscount && (
                      <div className="special-offer">Endirimli tur</div>
                    )}

                    <img src={tour.headerImageUrl} alt="moskva" />
                    <div className="text-div">
                      <h1>{tour.title}</h1>
                      <div className="country">
                        <img src={world} alt="icon" />
                        <h3>{tour.departure}</h3>
                      </div>
                      <div className="price-div">
                        <p>from</p>
                        <h2>
                          {" "}
                          {tour.currency === "USD" && "$"}
                          {tour.currency === "EUR" && "€"}
                          {tour.currency === "AZN" && "₼"}
                          {tour.hasDiscount ? tour.discountPrice : tour.price}
                        </h2>
                        {tour.hasDiscount && (
                          <h6 className="discount-price">{tour.price}</h6>
                        )}
                      </div>
                      <p className="bottom-text">
                        Bu təklifə nəzər salmağa nə deyirsiniz?
                      </p>
                    </div>
                    <Link
                      className="detail-button"
                      to={
                        lang === "az"
                          ? `/az/tour/${tour.slug}`
                          : `/en/tour/${tour.slug}`
                      }
                    >
                      {translation[currentLang].tourscardbutton}
                    </Link>
                  </div>
                </li>
              ))}
            </ul>
            <div className="pagination">
              {Array.from(
                { length: Math.ceil(tours.length / toursPerPage) },
                (_, index) => (
                  <button key={index + 1} onClick={() => paginate(index + 1)}>
                    {index + 1}
                  </button>
                )
              )}
            </div>
          </div>

          {filterOpen && (
            <div className="burger-overlay">
              <button
                className="close-button"
                onClick={() => setFilterOpen(false)}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
              <form>
                <h2 className="sorth2">
                  {translation[currentLang].toursfiltersortbytext}
                </h2>
                <div className="radio-div">
                  <input
                    type="radio"
                    name="option"
                    value="recommended"
                    checked={sortOption === "recommended"}
                    onChange={(e) => setSortOption(e.target.value)}
                  />{" "}
                  <label htmlFor="option">
                    {translation[currentLang].toursfilterlabelrecommended}
                  </label>
                </div>
                <div className="radio-div">
                  <input
                    type="radio"
                    name="option"
                    value="lowToHigh"
                    checked={sortOption === "lowToHigh"}
                    onChange={(e) => setSortOption(e.target.value)}
                  />{" "}
                  <label htmlFor="option">
                    {translation[currentLang].toursfilterlabellowtogigh}
                  </label>
                </div>
                <div className="radio-div">
                  <input
                    type="radio"
                    name="option"
                    value="highToLow"
                    checked={sortOption === "highToLow"}
                    onChange={(e) => setSortOption(e.target.value)}
                  />{" "}
                  <label htmlFor="option">
                    {translation[currentLang].toursfilterlabelhightolow}
                  </label>
                </div>

                <div className="total-div">
                  <h3>{translation[currentLang].toursfiltertotalprice}</h3>
                  <div className="prices-div">
                    <div className="price min-price">
                      <p>Min</p>
                      <div>
                        $
                        <input
                          className="price-input"
                          type="number"
                          placeholder="0"
                          name="min"
                          onChange={(e) => setMin(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="price max-price">
                      <p>Max</p>
                      <div>
                        $
                        <input
                          className="price-input"
                          type="number"
                          placeholder="3000+"
                          name="max"
                          onChange={(e) => setMax(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <input type="range" />

                <div className="special-div">
                  <h3>{translation[currentLang].toursfilteroffers}</h3>
                  <div className="radio-div">
                    <input type="radio" name="option" value="1" />{" "}
                    <label htmlFor="option">Istənilən</label>
                  </div>
                  <div className="radio-div">
                    <input type="radio" name="option" value="1" />{" "}
                    <label htmlFor="option">Xüsusi Təklif</label>
                  </div>
                </div>

                <div className="category-div">
                  <h3>{translation[currentLang].toursfiltercategories}</h3>

                  <ul>
                    {categories.map((category) => {
                      return (
                        <li>
                          <div className="radio-div">
                            <input
                              type="radio"
                              name="categorySort"
                              checked={categoryOption === category.id}
                              onChange={() => setCategoryOption(category.id)}
                            />{" "}
                            <label htmlFor="option">{category.name}</label>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <button
                  onClick={() => setFilterOpen(false)}
                  className="submit-button"
                  type="submit"
                >
                  {translation[currentLang].closebtn}
                </button>
              </form>
            </div>
          )}
        </section>
      </main>
    </>
  );
};

export default Tours;
